import React from 'react';

const SecurityContribution = () => {
  return <div>Serurity</div>;
};

export default SecurityContribution;
